import { Component, Input, OnInit } from '@angular/core';
import { NgIf } from '@angular/common';

@Component({
  selector: 'app-manual-address-entry-alert',
  templateUrl: './manual-address-entry-alert.component.html',
  standalone: true,
  imports: [NgIf],
  styleUrls: ['./manual-address-entry-alert.component.scss'],
})
export class ManualAddressEntryAlertComponent {
  @Input() isManualEntry: boolean = false;

  constructor() {}
}
